import { useCallback } from 'react'
import { useQueryParam, NumberParam } from 'use-query-params'

export type SetCurrentPage = (newPage: number) => void

export type UsePagination = () => [number, SetCurrentPage]

export const usePagination: UsePagination = () => {
  const [page, setPage] = useQueryParam('page', NumberParam)
  const currentPage = page || 1

  const setCurrentPage: SetCurrentPage = useCallback(
    (newPage: number) => setPage(newPage),
    [setPage],
  )

  return [currentPage, setCurrentPage]
}
